<template>
    <div class="form-group">
        <slot></slot>
    </div>
</template>

<style>
.form-group {
    @apply mb-4;
}
</style>
